export class BrowserHelper {
	
	public static isIE(): boolean {

		// Check if Internet Explorer based on User-Agent
		const isIE = /trident/i.test(window.navigator.userAgent);
		
		if (isIE) {
			return true;
		}

		// Check if Internet Explorer by duck typing
		// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

		return /*@cc_on!@*/false || !!document["documentMode"];
	}
	
	public static isSafari(): boolean {
		return navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0;
	}
}
